var MDB = window.MDB || {};;
MDB.Mangl = MDB.Mangl || {};
MDB.Mangl.Questions = MDB.Mangl.Questions || {};


(function($, MDB){
    var questionFieldTemplate = '[%s].Questions[%s].%s';

    function shouldTriggerEvent(event){
        if(!!event && !!event.target && event.dy !== 0) {
            return true;
        }

        return false;
    }

    function ondropactivate(fn){
        return function(event){
            if(fn) {
                fn(event);
            }            
            setClass(event.target, 'drop-active');
        }
    }

    function ondropdeactivate(fn){
        return function(event){
            if(fn) {
                fn(event);
            }            
            removeClass(event.target, 'drop-active');
            removeClass(event.target, 'drop-target');
        }
    }

    function ondragenter(fn){
        return function(event){
            if(fn) {
                fn(event);
            }            
            setClass(event.target, 'drop-target');
            setClass(event.relatedTarget, 'can-drop');
        }
    }

    function ondragleave(fn){
        return function(event){
            if(fn) {
                fn(event);
            }
            removeClass(event.target, 'drop-target');
            removeClass(event.relatedTarget, 'can-drop');
        }
    }

    function setClass(target, className){
        if(!target.classList.contains(className)) {
            target.classList.add(className);
        }
    }

    function removeClass(target, className){
        if(target.classList.contains(className)) {
            target.classList.remove(className);
        }
    }

    function ondrop(fn){
        return function(event){
            if(fn) {
                fn(event);
            }

            var dragEvent = event.dragEvent;

            var target = event.target
                , dropzoneEl = event.relatedTarget;

            dropzoneEl.style.top = '0px';

            var parent = target.parentElement;
            if(dropzoneEl.parentNode !== parent){
                if(dragEvent.dy > 0) {
                    dragEvent.dy = -1;
                }

                if(parent.children.length > 1){
                    if(target === parent.firstElementChild) {
                        dragEvent.dy = 0;
                    }
                    if(target === parent.lastElementChild) {
                        dragEvent.dy = 1;
                    }
                } else{
                    dragEvent.dy = 0;
                }

                parent.prepend(dropzoneEl);
            }

            var args = [dropzoneEl, target];
            if(dragEvent.dy > 0){
                //Position nodes next to eachother
                parent.insertBefore(dropzoneEl, target);

                //Swap positions in DOM                        
                parent.insertBefore(target, dropzoneEl);
            } else if (dragEvent.dy < 0){
                parent.insertBefore(dropzoneEl, target);
            }

        }
    }

    $.extend(MDB.Mangl.Questions, {
        bootDivisionConfiguration: function (containerSelector) {
            $(containerSelector).on('click', '[name$="ClassificationSelected"]', function() {
                var target = $(this)
                    , isChecked = this.checked;

                var row = target.closest('.classification-row')
                    , disableDoesNotApplyCheckbox = row.find('input[type="checkbox"].require-classification');

                if (isChecked) {
                    disableDoesNotApplyCheckbox.attr('disabled', null);
                } else {
                    disableDoesNotApplyCheckbox.attr('disabled', 'disabled');
                }
            });

            $(containerSelector).on('click', '[name$="IsSelected"]', function (e) {
                var collapseToggle = $(this).closest('.selectable-item-row').find('[data-toggle="collapse"]');
                var collapseTarget = $(collapseToggle.attr('href'));

                if (this.checked) {
                    collapseToggle.removeClass('hidden');
                } else {
                    collapseToggle.addClass('hidden');
                    collapseTarget.removeClass('show');
                }
            });
        },
        boot: function(){
            $('.btn-add').on('click', function(){
                MDB.Mangl.Questions.addQuestion();
            });

            $('.btn-save').on('click', function(){
                var form = $('form.save-handler');
                if(form.valid()){
                    MDB.Mangl.Questions.reIndexQuestions();                

                    form.find('input[type="checkbox"]').val(function(){
                        return this.checked;
                    });

                    form.trigger('submit');
                }
            });

            MDB.Mangl.Questions.initDragAndDrop();
        },
        addQuestion: function(selector){
            selector = selector || '.question-container:first';
            
            $.ajax({
                action: 'GET',
                url: 'AddQuestion',
                success: function(data){
                    $(selector).prepend(data);
                }
            });
        },
        reIndexQuestions: function(){
            $('.question-category').each(function(categoryIndex){
                $(this).find('.editable-question').each(function(questionIndex){
                    $(this).find('input,select').attr('name', function(){
                        var fieldName = this.name.replace( /\[.*\]\.?/, '');
                        var name = sprintf(questionFieldTemplate, categoryIndex, questionIndex, fieldName);

                        //Update validator
                        $(this).siblings('span[data-valmsg-for="' + this.name + '"]').attr('data-valmsg-for',name);

                        return name;
                    });
                });
            });
        },
        initDragAndDrop: function(){
            interact('.editable-question').draggable({
                max: 1,
                autoScroll: true,
                insertia: false,
                restrict: {
                    endOnly: true
                },
                snap: {
                    targets: [
                        //Create grid only for y axis to prevent horizontal movement
                        interact.createSnapGrid({ y: 1 })
                    ],
                    range: Infinity
                },
                onmove: function(event) {
                    if(!shouldTriggerEvent(event)) {
                        return;
                    }

                    var target = event.target;

                    setClass(target, 'dragging');

                    var top = target.style.top || '0px';
                    top = parseFloat(top.replace('[^0-9.]'));

                    target.style.top = (top + event.dy) + 'px';
                },
                onend: function (event) {
                    if(!shouldTriggerEvent(event)) {
                        return;
                    }

                    var target = event.target;

                    removeClass(target, 'dragging');

                    //Reset top before attempting to find the swappable nodes
                    $(target).parents('.question-container').find('.editable-question').css('top', 0);
                }
            }).allowFrom('.handle').styleCursor(false);;

            interact('.question-category').dropzone({
                accept: '.editable-question',
                overlap: 0.25,
                ondropactivate: ondropactivate(),
                ondragenter: ondragenter(),
                ondragleave: ondragleave(),
                ondropdeactivate: ondropdeactivate(),
                ondrop: ondrop(function(event){
                    var target = event.target
                        , dropzoneEl = event.relatedTarget;
                    
                    target = $(target).find('.question-container')[0];
                    if(dropzoneEl.parentNode !== target && !target.firstElementChild) {
                        target.append(event.relatedTarget);
                    }

                    event.target = target.firstElementChild;
                })
            });

            interact('.editable-question').dropzone({
                accept: '.editable-question',
                overlap: 0.5,
                ondropactivate: ondropactivate(),
                ondragenter: ondragenter(),
                ondragleave: ondragleave(),
                ondropdeactivate: ondropdeactivate(),
                ondrop: ondrop()
            });

            interact.maxInteractions(Infinity);
        }
    });
})(jQuery, MDB);